/**
 * No-op console in production so no logs are emitted in prod (lower envs only).
 * Call early from index.js; runs again after a short delay in case window._env_ loads async.
 */

const noop = () => {};

function isProd() {
  if (typeof window === 'undefined') return false;
  const env = (window._env_?.ENVIRONMENT || window._env_?.environment || '').toString().toLowerCase();
  return env === 'prod' || env === 'production';
}

let patched = false;

export function disableConsoleInProd() {
  if (patched || !isProd()) return;
  patched = true;
  try {
    ['log', 'info', 'debug', 'warn', 'error'].forEach((method) => {
      if (typeof console[method] === 'function') {
        console[method] = noop;
      }
    });
  } catch (_) {}
}
